
import { FiArrowRight, FiEye } from "react-icons/fi";
import editorImage from "../assets/editor_screen.png";

export function HeroSection() {
  return (
    <section className="hero">
        <div className="hero-content">
            <h1>Write in LaTeX and generate PDF files instantly.</h1>
            <p>A modern editor with real-time preview, collaboration, and templates for academic and technical documents.</p>
            <div className="hero-ctas">
                <a href="/login" className="button">Start Writing Free <FiArrowRight /></a>
                <a href="/login" className="button button-outline"><FiEye /> View Examples</a>
            </div>
            <p className="hero-note">No credit card required.</p>
        </div>
        <div className="hero-visual">
            <div className="showcase-image">
                <img src={editorImage} alt="CoffeeLaTek Editor" />
            </div>
        </div>
    </section>
  );
}
